import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Promotion, PromotionStatus } from '../types';
import { PromotionCard } from '../PromotionCard';
import { Plus } from 'lucide-react';
interface CardDashboardViewProps {
  promotions: Promotion[];
  onEdit: (id: string) => void;
  onDelete: (id: string) => void;
  onStatusChange: (id: string, status: PromotionStatus) => void;
  onAddNew: () => void;
}
export function CardDashboardView({
  promotions,
  onEdit,
  onDelete,
  onStatusChange,
  onAddNew
}: CardDashboardViewProps) {
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.05
      }
    }
  };
  return <motion.div variants={container} initial="hidden" animate="show" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-169">
      <motion.button whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} onClick={onAddNew} className="flex flex-col items-center justify-center p-8 border-2 border-dashed border-gray-300 rounded-xl hover:border-blue-500 hover:bg-blue-50/50 transition-all group min-h-[250px]" data-id="element-170">
        <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mb-4 group-hover:bg-blue-100 transition-colors" data-id="element-171">
          <Plus className="w-6 h-6 text-gray-400 group-hover:text-blue-600" data-id="element-172" />
        </div>
        <span className="font-semibold text-gray-900" data-id="element-173">Add New Promotion</span>
        <span className="text-sm text-gray-500 mt-1" data-id="element-174">
          Track a new bonus opportunity
        </span>
      </motion.button>

      {promotions.map(promotion => <PromotionCard key={promotion.id} promotion={promotion} onEdit={onEdit} onDelete={onDelete} onStatusChange={onStatusChange} data-id="element-175" />)}
    </motion.div>;
}